import detailDefault from "../../detailDefault";

export default class detailUsers extends detailDefault {
    load(sAction, data) {
    }
    update(sAction, data) { }
}
